import Head from './../components/Head.vue';
import CourseCard from './../components/CourseCard';
import SpocCard from '../components/SpocCourseCard.vue';
import { getUrlParams } from '@/plugins/utils';
import { Empty } from 'zhs-components';
import Footer from '../components/Footer.vue';
export default {
  components: {
    Head,
    CourseCard,
    Empty,
    SpocCard,
    Footer
  },

  created() {
    if (getUrlParams('type')) {
      this.courseType = getUrlParams('type');
      this.getMoocSet();
      this.getCourseList();
      this.getFilterList();
    }
  },

  mounted() {
    this.getAuth();
  },

  watch: {
    searchInfo: {
      handler(value) {
        this.pageInfo.pageIndex = 1;
        this.getCourseList();
      },

      deep: true
    },
    classifyId: {
      handler(value) {
        this.getFilterList();
      }

    }
  },

  data() {
    return {
      menuId: this.$utils.getUrlParams('menuId'),
      title: '',
      pageInfo: {
        pageLimit: 12,
        pageIndex: 1,
        rows: 0
      },
      menuInfo: {},
      classifyId: null,
      searchInfo: {
        collegeId: '',
        courseResultsId: '',
        subjectId: '',
        subjectOneId: '',
        subjectTwoId: '',
        selectedAchievementKind: '',
        collegeName: '',
        subjectName: '',
        termId: '',
        schoolyearId: '',
        termName: '',
        sortNum: 1,
        sortName: '综合排序'
      },
      courseType: '1',
      // 课程类型 1 MOOC开放课  2 SPOC校本课
      moocMenuId: '',
      spocMenuId: '',
      setlist: null,
      // 高级设置
      courseList: [],
      courseName: '',
      // 搜索关键字
      sortTypeList: [{
        name: '综合排序',
        code: 1
      }, {
        name: '按选课人数降序',
        code: 3
      }, {
        name: '按选课人数升序',
        code: 2
      }],
      classifyList: [],
      // 分类列表
      subjectList: [],
      // 学科列表
      achievementKindList: [],
      // 课程成果
      categoryList: [],
      termList: [],
      // 学期列表
      hiddenMoreClass: true,
      classify_flag: '',
      results_flag: '',
      organ_flag: '',
      subject_flag: '',
      term_flag: '',
      showAffix: true,
      showMoreCourseKind: false,
      // 是否显示更多课程成果
      showMoreCollege: false,
      // 是否显示更多学院
      showMoreSubject: false,
      // 是否显示更多学科
      showMoreTerm: false,
      // 是否显示更多学期
      sortType: 1,
      // 排序类型 1 按选课学生  2 按选课学校数
      authType: 0,
      userInfo: null,
      resultMap: {},
      reusltColorList: ['#E1212F', '#DA7712', '#00AD3D', '#0089C4', '#7359CA'],
      showResultTag: false // 是否显卡成果标签

    };
  },

  methods: {
    getUserInfo(data) {
      this.userInfo = data;
      console.log(this.userInfo);
    },

    // 获取课程列表
    async getCourseList() {
      const courseList = await this.$http.getCourseList({
        '_pageable.page': this.pageInfo.pageIndex - 1,
        '_pageable.size': this.pageInfo.pageLimit,
        course_type: this.courseType,
        menu_id: this.menuId,
        // menu_id: this.courseType == 1 ? this.moocMenuId : this.spocMenuId,
        order: this.searchInfo.sortNum,
        subject_id: this.searchInfo.subjectId || undefined,
        course_name: this.courseName || undefined,
        classify_id: this.classifyId || undefined,
        organ_id: this.searchInfo.collegeId || undefined,
        results_id: this.searchInfo.courseResultsId || undefined,
        semester_id: this.searchInfo.termId || undefined,
        schoolyear_id: this.searchInfo.schoolyearId || undefined
      }); // console.log('课程列表', courseList);

      this.courseList = courseList.content || [];
      this.pageInfo.rows = +courseList.totalElements || 0;
    },

    // 课程搜索
    handleSearch() {
      this.pageInfo.pageIndex = 1;
      this.getCourseList();
    },

    // 查询高级设置
    async getMoocSet() {
      // console.log(this.moocMenuId);
      if (this.courseType == 1) {
        const res = await this.$http.getMoocSet({
          menu_id: this.menuId // menu_id: this.moocMenuId

        });
        this.setlist = res.res_last;
        console.log('set', res);
      }

      if (this.courseType == 2) {
        const res = await this.$http.getSpocSet({
          menu_id: this.menuId
        });
        this.setlist = res.res_last;
        console.log('set', res);
      }

      this.getCourseResultTagStatus();
      this.setlist.forEach(item => {
        if (item.code == 'sort_type') {
          let sorts = {
            1: '综合排序',
            2: '按选课人数升序',
            3: '按选课人数降序'
          };
          this.searchInfo.sortName = sorts[item.code_value];
          this.searchInfo.sortNum = item.code_value;
        }

        if (item.code == 'classify_flag') {
          this.classify_flag = item.code_value;
        }

        if (item.code == 'results_flag') {
          this.results_flag = item.code_value;
        }

        if (item.code == 'organ_flag') {
          this.organ_flag = item.code_value;
        }

        if (item.code == 'subject_flag') {
          this.subject_flag = item.code_value;
        }

        if (item.code == 'term_flag') {
          this.term_flag = item.code_value;
        }
      });
    },

    // 获取课程成果标签状态
    async getCourseResultTagStatus() {
      const res = await this.$http.getAchievementTagStatus({
        menu_id: this.menuId,
        codeName: 'course_achievement_show_flag'
      });
      this.showResultTag = +res > 0 ? true : false;
    },

    // 切换排序
    handleSort(item, index) {
      this.searchInfo.sortNum = item.code;
      this.searchInfo.sortName = item.name;
      this.getCourseList();
    },

    // 获取筛选列表
    async getFilterList() {
      let params = {
        course_type: this.courseType,
        classify_id: this.classifyId || '',
        menu_id: this.menuId // menu_id: this.courseType == 1 ? this.moocMenuId : this.spocMenuId

      };
      const res = await this.$http.getFilterList(params);
      console.log('筛选列表', res);
      this.classifyList = res.classify_list;
      this.categoryList = res.organ_tree.children || [];
      let organNum = res.organ_tree.courseNum;
      this.categoryList.unshift({
        organName: '全部',
        courseNum: organNum,
        id: ''
      });
      this.achievementKindList = res.results_list;
      this.achievementKindList.forEach((item, index) => {
        if (item.name == '全部') {
          item.id = '';
        } else {
          if (this.resultMap[item.id]) return;

          if (index > this.reusltColorList.length) {
            this.resultMap[item.id] = this.reusltColorList[index % this.reusltColorList.length - 1];
          } else {
            this.resultMap[item.id] = this.reusltColorList[index - 1];
          }
        }
      });
      let subjectNum = res.subject_tree.courseNum;
      this.subjectList = res.subject_tree.children || [];
      this.subjectList.unshift({
        subjectName: '全部',
        courseNum: subjectNum,
        id: ''
      });
      this.termList = res.term_list;
      this.termList.forEach(item => {
        if (item.schoolyear == '全部') {
          item.semester_id = '';
          item.schoolyear_id = '';
        }
      });
    },

    // 点击分类筛选课程
    searchCourseList(id) {
      this.pageInfo.pageIndex = 1;
      this.classifyId = id;
      this.getCourseList();
    },

    // 清空选中
    clearSelected(index) {
      if (index === 1) {
        this.searchInfo.courseResultsId = '';
      } else if (index === 2) {
        this.searchInfo.collegeId = '';
      } else if (index === 3) {
        this.searchInfo.subjectId = '';
      } else {
        this.searchInfo.termId = '';
        this.searchInfo.schoolyearId = '';
        this.searchInfo.termName = '';
      }

      this.pageInfo.pageIndex = 1;
    },

    // 切换课程成果显示
    toggleShowCourseKind() {
      this.showMoreCourseKind = !this.showMoreCourseKind;
    },

    // 切换课程成果
    courseResultChange(item) {
      this.searchInfo.courseResultsId = item.id;
      this.searchInfo.selectedAchievementKind = item.name;
      this.pageInfo.pageIndex = 1;
    },

    // 切换学期显示
    toggleShowTerm() {
      this.showMoreTerm = !this.showMoreTerm;
    },

    // 切换学期
    termChange(item) {
      this.searchInfo.termId = item.semester_id;
      this.searchInfo.schoolyearId = item.schoolyear_id;
      this.searchInfo.semester = item.semester;
      this.searchInfo.termName = item.schoolyear;
      this.pageInfo.pageIndex = 1;
    },

    // 切换学院显示
    toggleShowCollege() {
      this.showMoreCollege = !this.showMoreCollege;
    },

    // 切换学院
    collegeChange(item) {
      this.searchInfo.collegeId = item.id;
      this.searchInfo.collegeName = item.organName;
      this.pageInfo.pageIndex = 1;
    },

    twoCollegeChange(item) {
      this.searchInfo.collegeId = item.id;
      this.searchInfo.collegeName = item.organName;
      this.pageInfo.pageIndex = 1;
    },

    // 切换学科显示
    toggleShowSubject() {
      this.showMoreSubject = !this.showMoreSubject;
    },

    // 切换一级学科
    oneSubjectChange(item) {
      // this.searchInfo.subjectOneId = item.id
      this.searchInfo.subjectId = item.id;
      this.searchInfo.subjectName = item.subjectName; // console.log('one', this.searchInfo.subjectOneId);

      this.pageInfo.pageIndex = 1;
    },

    // 切换二级学科
    twoSubjectChange(item) {
      // this.searchInfo.subjectTwoId = item.id
      this.searchInfo.subjectId = item.id;
      this.searchInfo.subjectName = item.subjectName;
      this.pageInfo.pageIndex = 1; // console.log('two', this.searchInfo.subjectTwoId);
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getCourseList();
    },

    MoocPage(data) {
      this.title = data;
    },

    SpocName(data) {
      this.title = data;
    },

    async getAuth() {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      const res2 = await this.$http.getConfigList();

      if (this.courseType == 1) {
        this.authType = navItemInfo.find(item => item.function_id == '10401').auth_type;
      } else {
        this.authType = navItemInfo.find(item => item.function_id == '10402').auth_type;
      }
    }

  }
};